// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — zone.styled.classic.js, новая — zone.styled.cp.js
import { isCp } from 'libs/design';
import * as classic from './zone.styled.classic';
import * as cp from './zone.styled.cp';

export const Content = isCp ? cp.Content : classic.Content;
